import { render, staticRenderFns } from "./despachadoTable.vue?vue&type=template&id=16addc70&"
import script from "./despachadoTable.vue?vue&type=script&lang=js&"
export * from "./despachadoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports